export const INVOICE_DETAIL = "INVOICE_DETAIL"
export const INVOICE_DETAIL_SUCCESS = "INVOICE_DETAIL_SUCCESS"
export const INVOICE_DETAIL_ERROR = "INVOICE_DETAIL_ERROR"

export const INVOICE_SELECT = "INVOICE_SELECT"
export const INVOICE_SELECT_SUCCESS = "INVOICE_SELECT_SUCCESS"
export const INVOICE_SELECT_ERROR = "INVOICE_SELECT_ERROR"

export const INVOICE_UPDATE = "INVOICE_UPDATE"
export const INVOICE_UPDATE_SUCCESS = "INVOICE_UPDATE_SUCCESS"
export const INVOICE_UPDATE_ERROR = "INVOICE_UPDATE_ERROR"
